export const WorkshopCategoryPermissionKeys = Object.freeze({
  LIST: {
    VIEW: 'product.workshopCategory.list-view',
    UPDATE: 'product.workshopCategory.list-update',
    DELETE: 'product.workshopCategory.list-delete',
  },
});
